import * as nodeCrypto from 'crypto';
const { performance } = require('perf_hooks');

export const location = {
    href: 'https://adf.azure.com/home?factory=/subscriptions/<subId>/resourcegroups/<rgName>/providers/Microsoft.DataFactory/factories/<dfName>'
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const Msal = {
    UserAgentApplication: {},
    InteractionRequiredAuthError: { },
    ServerError: {}
};

export const now = performance.now.bind(performance);

export const getRandomValues = nodeCrypto.randomFillSync;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const addEventListener: (_type: string, listener: (param: any) => any) => void = () => { /*nothing*/ };
